"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_button_1 = require("@doordash/component-button");
var component_list_cell_1 = __importDefault(require("@doordash/component-list-cell"));
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var ReadOnlyLink_1 = require("../ReadOnlyLink");
var Search_1 = __importDefault(require("../Search"));
var styles_1 = require("./styles");
var Autocomplete = function (_a) {
    var label = _a.label, onChange = _a.onChange, value = _a.value, onSearch = _a.onSearch, _b = _a.minimumResultCharLength, minimumResultCharLength = _b === void 0 ? 2 : _b, getRecordById = _a.getRecordById, searchResultFormat = _a.searchResultFormat, linkFormat = _a.linkFormat, debounceSensitivity = _a.debounceSensitivity, error = _a.error;
    var _c = React.useState(false), editIntention = _c[0], setEditIntention = _c[1];
    var _d = React.useState(), record = _d[0], setRecord = _d[1];
    React.useEffect(function () {
        var fetchValue = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = setRecord;
                        return [4 /*yield*/, getRecordById(value)];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        console.warn(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchValue();
    }, [value]);
    var isEditable = editIntention || !record;
    return (React.createElement(design_language_1.StackChildren, { size: design_language_1.StackChildren.Sizes.None },
        React.createElement(design_language_1.Text, { size: design_language_1.Text.Sizes.S14 }, label),
        React.createElement(design_language_1.Stack, { size: design_language_1.Stack.Sizes.XSmall }),
        isEditable ? (React.createElement(design_language_1.InlineChildren, { size: design_language_1.InlineChildren.Sizes.XxxSmall },
            React.createElement(design_language_1.StackChildren, { size: design_language_1.InlineChildren.Sizes.XxxSmall, alignItems: design_language_1.InlineChildren.Alignment.Center },
                React.createElement(Search_1["default"], { error: error, isLabelHidden: true, label: label, minimumResultCharLength: minimumResultCharLength, onSearch: onSearch, debounceSensitivity: debounceSensitivity, onResults: function (results) { return (React.createElement(styles_1.SearchResultsWrapper, null, results.map(function (result) { return (React.createElement(component_list_cell_1["default"], { key: result.id, size: component_list_cell_1["default"].Sizes.Small, onClick: function () {
                            setEditIntention(false);
                            onChange(result.id);
                        }, title: searchResultFormat(result) })); }))); } })),
            editIntention && (React.createElement(component_button_1.IconButton, { accessibilityLabel: "Cancel Edit", iconType: design_language_1.Icon.Types.Close, onClick: function () { return setEditIntention(false); } })))) : (React.createElement(design_language_1.InlineChildren, { size: design_language_1.InlineChildren.Sizes.XxxSmall, alignItems: design_language_1.InlineChildren.Alignment.Center },
            React.createElement(ReadOnlyLink_1.ReadOnlyLink, { link: linkFormat(record), value: searchResultFormat(record) }),
            React.createElement(component_button_1.IconButton, { accessibilityLabel: "Edit", iconType: design_language_1.Icon.Types.EditLine, onClick: function () { return setEditIntention(true); } })))));
};
exports["default"] = Autocomplete;
